angular.module('swapick')

.controller('AppCtrl', function($scope, PermissionStore,
    Entities, $rootScope, $state, $auth,
    $ionicSideMenuDelegate, $ionicHistory, Filters,
    DataService, NotificationStore, baseServerUrl ) {

  this.logged = () => $auth.isAuthenticated();
  this.user = () => Entities.getUser();

  $rootScope.globals = $rootScope.globals || {};

  this.userEmail = () => {
    let o = this.user();
    return o ? o.email : null;
  }

  this.logout = () => {
    $auth.logout()
    Entities.logout();
    this.resetUser();
    //PermissionStore.clearStore();
    $ionicHistory.clearCache();
    $ionicHistory.clearHistory();
    $ionicSideMenuDelegate.toggleLeft(false);
    Filters.removeAllFilters();
    console.log("deregister device!")
    let deviceToken = NotificationStore.getDeviceToken();
    console.log(1, "register device!", deviceToken)
    if(deviceToken){
      DataService.device.remove({
        platform : ionic.Platform.platform(),
        token : deviceToken
      })
    }
    $rootScope.$broadcast("app:logoutSuccess");
  };

  this.toggleWanted = (obj, isWanted) => {
    if(isWanted){
      DataService.wanted
      .one(obj.id.toString())
      .remove()
      .then(resp => {
          obj.voluto = false;
      })
    } else {
      DataService.wanted
      .post({id:obj.id})
      .then(resp => {
          obj.voluto = true;
      })
    }
  }

  this.toBuyPage = (obj) => {

    return $state.go("app.logged.buy",
      {yourObjectId:obj.id, myMoney:obj.posseduto_da[0].valore}
    );
  }

  this.toObjPage = (obj) => {
    return $state.go("app.logged.object",
      {objectId:obj.id, userId:obj.posseduto_da[0].user.id, objFromList:obj}
    );
  }

  this.resetUser = () => {
    return Entities.waitForUser()
    .then(u=>{
      this.loggedUser = u;
      let deviceToken = NotificationStore.getDeviceToken();
      console.log(1, "register device!", deviceToken)
      if(deviceToken){
        DataService.devices.post({
          platform : ionic.Platform.platform(),
          token : deviceToken
        })
      }
      return DataService.itemsIcanGet
      .get({type:'proposte', 'count_only':1})
      .then(resp => {
        $rootScope.globals.totalItemsICanGet = resp.total_items
        return resp;
      })
    })
    .then(()=>{
      DataService.swaps
      .getList({type:'proposte'})
      .then(resp => {
        $rootScope.globals.totalNewSwaps = resp.metadata.count;
        return resp;
      })
    })
    .then(()=>{
      DataService.ecoins
      .get()
      .then(resp => {
        $rootScope.globals.userEcoins = parseInt(resp);
        return resp;
      })
    })
  }

  //#TODO
  this.fixImageUrl = url => {
    if(!url){return url}
    return url.replace("https://api.swapick.com/uploads/", 'http://45.32.153.130/uploads/')
  }

  this.resetUser()

  this.openHelp = () => {
    window.open('http://test.swapick.it/come-funziona', '_system');
  }

  this.openTerms = () => {
    window.open('http://test.swapick.it/come-funziona#termini-condizioni', '_system');
  }


})



// WEBPACK FOOTER //
// ./src/controllers/app-controller.js